angular.module('NiacsProjectApp.services', [
  'NiacsProjectApp.services-general',
  'NiacsProjectApp.services-strategy',
  'NiacsProjectApp.services-resources',
  'NiacsProjectApp.services-project',
  'NiacsProjectApp.services-dialog',
  ]
);
